import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody
} from '@chakra-ui/react';
import CustomChakraButton from '../../../CustomChakraButton/CustomChakraButton';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onConfirmWithCashWithdrawal: () => void;
}

export const ConfirmCancelingPopup = ({ isOpen, onClose, onConfirm, onConfirmWithCashWithdrawal }: Props) => {
  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay
        sx={{
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }}
      />
      <ModalContent>
        <ModalHeader className="flex flex-col gap-spacing-xl">
          <h2 className="font-semibold text-lg text-grayLight-900">Wycofanie stawek</h2>
          <div className="font-normal text-sm text-grayLight-900 justify-center items-center">
          <CustomChakraButton
              hierarchy="primary"
              size="sm"
              iconPosition="onlyText"
              buttonProps={{
                type: 'button',
                onClick: () => {
                  onConfirm();
                }
              }}>
              Wycofaj stawki i wpłać na saldo
            </CustomChakraButton>
            <div className="w-full flex gap-4 p-4">
              Środki z wycofanych stawek trafiają na saldo konsumenta<br/>
            </div>
            <CustomChakraButton
              hierarchy="primary"
              size="sm"
              iconPosition="onlyText"
              buttonProps={{
                type: 'button',
                onClick: () => {
                  onConfirmWithCashWithdrawal();
                }
              }}>
              Wycofaj stawki i wypłać środki użytkownikowi w gotówce.
            </CustomChakraButton>
            <div className="w-full flex gap-4 p-4">
              Środki z wycofanych stawek zostaną zwrócone na saldo a następnie zostanie doknana wypłata gotówkowa o wartości równej sumie wartości anulowanych stawek.
            </div>
          </div>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody className="grid gap-spacing-3xl">
          <div className="w-full flex justify-center gap-4 p-4">
            <CustomChakraButton
              hierarchy="secondaryColor"
              size="sm"
              iconPosition="onlyText"
              buttonProps={{
                type: 'button',
                onClick: () => onClose()
              }}>
              Wróć
            </CustomChakraButton>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
